







































































































































import TableComp from '@/components/Common/TableComp.vue';
import SubmitBtn from '@/components/Common/SubmitBtn.vue';
import TableOperaBtn from '@/components/Common/TableOperaBtn.vue';
import BatchTransferStudentDialog from './BatchTransferStudentDialog.vue'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
@Component({
  name: 'studentQueryList',
  components: {
    TableComp,
    SubmitBtn,
    TableOperaBtn,
    BatchTransferStudentDialog
  },
})
export default class extends Vue {
  @Prop({ default: () => [] }) public tableData!: any[];
  @Prop({ default: () => ({}) }) public tablePage!: any[];

  public selectList: any = [];
  public showTransferDialog = false;

  public handleSizeChange(pageSize: number) {
    this.$emit('page-size-change', pageSize);
  }

  public handleCurrentChange(currentPage: number) {
    this.$emit('page-current-change', currentPage);
  }

  public handleRowClick({ row }: { row: any, column: any}) {
    this.$emit('row-click', row);
  }
  @Emit('do-sort')
  public handleSort(type: string) {
    return type;
  }
  // 勾选列表
  public handleSelectionChange(selects: any) {
    this.selectList = selects;
  }
  // 批量转学生管理账号
  public showBatchTransferStudent() {
    if (this.selectList.length) {
      this.showTransferDialog = true;
    } else {
      this.$message.info(this.$t('common.plsSelect') as string);
    }
  }
}
